

const initSlider = () => {
  const track = document.querySelector('.reviews-slider__track');
  if (!track) return;

  const blocks = track.querySelectorAll('.review-block');
  if (blocks.length < 2) return;

  const scrollDuration = (parseInt(track.dataset.scrollDuration, 10) || 4) * 1000;
  const reviewHeight = parseInt(track.dataset.reviewHeight, 10);
  const reviewHeightMobile = parseInt(track.dataset.reviewHeightMobile, 10);

  // Clone each block for seamless loop
  blocks.forEach(block => {
    const clone = block.cloneNode(true);
    clone.classList.add('clone');
    track.appendChild(clone);
  });

  const allBlocks = track.querySelectorAll('.review-block');
  let index = 0;

  function setupVertical() {
    track.classList.remove('horizontal');

    const blockStyle = window.getComputedStyle(blocks[0]);
    const blockHeight = blocks[0].offsetHeight
                      + (parseFloat(blockStyle.marginTop) || 0)
                      + (parseFloat(blockStyle.marginBottom) || 0);

    track.style.height = `${blockHeight * allBlocks.length}px`;
    track.style.width = 'auto';
    
    allBlocks.forEach(block => {
      block.style.maxW = '';
    });

    function scrollToNextVertical() {
      index++;
      
      track.style.transition = 'transform 0.6s ease-in-out';
      track.style.transform = `translateY(-${index * blockHeight}px)`;

      if (index === allBlocks.length / 2) {
        setTimeout(() => {
          track.style.transition = 'none';
          track.style.transform = 'translateY(0)';
          index = 0;

          // Force reflow to fix flicker/glitch
          track.offsetHeight;

          // Re-enable transition for next scroll
          setTimeout(() => {
            track.style.transition = 'transform 0.6s ease-in-out';
          }, 20);
        }, 600);
      }
    }

    return scrollToNextVertical;
  }

  function setupHorizontal() {
    track.classList.add('horizontal');
    
    const blockWidth = document.documentElement.clientWidth - 40;

    track.style.width = `${blockWidth * allBlocks.length}px`;
    track.style.height = `${reviewHeightMobile}px`; // fixed height
    
    allBlocks.forEach(block => {
      block.style.maxWidth = `${blockWidth}px`;
      block.style.flexShrink = '0';
    });

    function scrollToNextHorizontal() {
      index++;
      track.style.transition = 'transform 0.6s ease-in-out';
      track.style.transform = `translateX(-${index * blockWidth + (20 * index)}px)`;

      if (index === blocks.length) {
        setTimeout(() => {
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          index = 0;

          // Force reflow to fix flicker/glitch
          track.offsetHeight;

          // Re-enable transition for next scroll
          setTimeout(() => {
            track.style.transition = 'transform 0.6s ease-in-out';
          }, 20);
        }, 600);
      }
    }

    return scrollToNextHorizontal;
  }
  
  let scrollFunc = document.documentElement.clientWidth < 768 ? setupHorizontal() : setupVertical();

  let interval = setInterval(scrollFunc, scrollDuration);

  // Listen for resize to switch behavior dynamically
  window.addEventListener('resize', () => {
    clearInterval(interval);
    index = 0;
    track.style.transition = 'none';
    track.style.transform = 'translate(0, 0)';

    scrollFunc = document.documentElement.clientWidth < 768 ? setupHorizontal() : setupVertical();
    interval = setInterval(scrollFunc, scrollDuration);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  requestAnimationFrame(() => {
    initSlider();

    // Fix for reviews
    if (window.innerWidth < 768) {
      setTimeout(() => {
        const rightReveal = document.querySelector('.reviews-slider__right')?.closest('animation-reveal');

        if (rightReveal && typeof rightReveal.animateImageTxt === 'function') {
          rightReveal.animateImageTxt({ target: rightReveal });
        }
      }, 500);
    }
  });
}); 